import { Box, Container } from '@mui/material';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import { COLOR_PURPLE } from 'styles/variables/colors';

const Props = {
  bgColorProps: PropTypes.string,
  sizeProps: PropTypes.number,
  heightProps: PropTypes.string,
};

const DefaultProps = {
  bgColorProps: '#FFFFFF',
  sizeProps: 40,
  heightProps: '100vh',
};

export default function LoadingCircle({ bgColorProps, sizeProps, heightProps }) {
  return (
    <Box bgcolor={bgColorProps}>
      <Container>
        <Box display="flex" justifyContent="center" alignItems="center" height={heightProps}>
          <CircularProgress size={sizeProps} style={{ color: COLOR_PURPLE }} />
        </Box>
      </Container>
    </Box>
  );
}

LoadingCircle.propTypes = Props;
LoadingCircle.defaultProps = DefaultProps;
